<template>
    <b-card>
            <b-button block variant="outline-secondary" class="mb-1 w-100" @click="setform('hostScheduleResetCheckTime')">
                <i class="fa-solid fa-arrows-rotate"></i>
                {{ $t('action-items.reset-check-time') }}
            </b-button>
            <b-collapse v-model="hostScheduleResetCheckTime" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-reset-check-time :hostuuid="getUuid" :satelliteId="satelliteId"  @refresh="actionRefresh"></host-reset-check-time>
                </b-list-group-item>
            </b-collapse>
            <b-button block  variant="outline-secondary" class="mb-1 w-100"  @click="setform('ScheduleMaintenance')"
                      v-if="this.getHostStatus.scheduledDowntimeDepth === 0">
                <i class="fa-solid fa-power-off"></i>
                {{ $t('action-items.schedule-maintenance') }}
            </b-button>
            <b-button block variant="outline-danger" class="mb-1 w-100" @click="setform('ScheduleMaintenance')"
                      v-if="this.getHostStatus.scheduledDowntimeDepth > 0 && this.getDeleteDowntimePermission">
                <i class="fa-solid fa-trash"></i>
                {{ $t('action-items.remove-schedule-maintenance') }}
            </b-button>
            <b-collapse v-model="ScheduleMaintenance" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-downtime :hostuuid="getUuid" :downtime="getDowntime"
                                   :hoststatus="getHostStatus" @refresh="actionRefresh"></host-downtime>
                </b-list-group-item>
            </b-collapse>
            <span v-if="getHostStatus.currentState > 0">
                <b-button block  variant="outline-secondary" class="mb-1 w-100" @click="setform('acknowledge')"
                          v-if="!this.getHostStatus.problemHasBeenAcknowledged">
                    <i class="fa-solid fa-user"></i>
                    {{ $t('action-items.acknowledge-host-status') }}
                </b-button>

                <b-button block  variant="outline-danger" class="mb-1 w-100" ref="acknowledge" @click="setform('acknowledge')"
                          v-if="this.getHostStatus.problemHasBeenAcknowledged && this.$store.state.canDeleteAcknowledgements">
                    <i class="fa-solid fa-trash"></i>
                    {{ $t('action-items.remove-acknowledge') }}
                </b-button>
            </span>
            <b-collapse v-model="acknowledge" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-acknowledge :hostuuid="getUuid" :hostid="hostid" :services="getServices"
                                      :problemHasBeenAcknowledged="getHostStatus.problemHasBeenAcknowledged"
                                      @refresh="actionRefresh"></host-acknowledge>
                </b-list-group-item>
            </b-collapse>

            <b-button block @click="setform('togglePassiveColapse')" variant="outline-secondary" class="mb-1 w-100">
                <i class="fa-solid fa-download"></i>
                {{ $t('action-items.passive-transport') }}
            </b-button>
            <b-collapse v-model="togglePassiveColapse" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-passive-check :hostuuid="getUuid"
                                        @refresh="actionRefresh"></host-passive-check>
                </b-list-group-item>
            </b-collapse>
            <b-button block @click="setform('flapDetect')" variant="outline-secondary" class="mb-1 w-100"
                      v-if="!this.getHostStatus.flap_detection_enabled">
                <i class="fa-solid fa-circle-half-stroke"></i>
                {{ $t('action-items.flap-detection-enable') }}
            </b-button>
            <b-button block @click="setform('flapDetect')" variant="outline-secondary" class="mb-1 w-100"
                      v-if="this.getHostStatus.flap_detection_enabled">
                <i class="fa-solid fa-circle-half-stroke"></i>
                {{ $t('action-items.flap-detection-disable') }}
            </b-button>
            <b-collapse v-model="flapDetect" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-flapdetection :hostuuid="getUuid"
                                        :flapDetectionEnabled="getHostStatus.flap_detection_enabled"
                                        @refresh="actionRefresh"></host-flapdetection>
                </b-list-group-item>
            </b-collapse>
            <b-button block variant="outline-secondary" class="mb-1 w-100" @click="setform('notification')"
                      v-if="this.getHostStatus.notifications_enabled">
                <i class="fa-solid fa-envelope"></i>
                {{ $t('action-items.notifications-disable') }}
            </b-button>

            <b-button block variant="outline-secondary" class="mb-1 w-100"  @click="setform('notification')"
                      v-if="!this.getHostStatus.notifications_enabled">
                <i class="fa-solid fa-envelope"></i>
                {{ $t('action-items.notifications-enable') }}
            </b-button>
            <b-collapse v-model="notification" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-notifications :hostuuid="getUuid"
                                        :notificationsEnabled="getHostStatus.notifications_enabled"
                                        @refresh="actionRefresh"></host-notifications>

                </b-list-group-item>
            </b-collapse>
            <b-button class="w-100 mb-1 w-100"
                      variant="outline-secondary"
                      @click="setform('toggleCustomNotification')">
                <i class="fa-solid fa-envelope-open"></i>
                {{ $t('action-items.custom-notification') }}
            </b-button>
            <b-collapse v-model="toggleCustomNotification" accordion="my-accordion" role="tabpanel" class="mt-2 mb-2">
                <b-list-group-item>
                    <host-custom-notification :hostuuid="getUuid"
                                        @refresh="actionRefresh"></host-custom-notification>

                </b-list-group-item>
            </b-collapse>

    </b-card>
</template>

<script>
import HostAcknowledge from "./HostAcknowledge";
import HostDowntime from "./HostDowntime";
import HostResetCheckTime from "./HostResetCheckTime";
import HostPassiveCheck from "./HostPassiveCheck";
import HostFlapdetection from "./HostFlapdetection";
import HostNotifications from "./HostNotifications";
import HostCustomNotification from "./HostCustomNotification";

export default {
    name: "HostExternalCommands",
    components: {
        HostNotifications,
        HostFlapdetection, HostPassiveCheck,
        HostResetCheckTime, HostDowntime, HostAcknowledge,
        HostCustomNotification
    },
    props: [
        'hostuuid',
        'hostid',
        'satelliteId',
        'current_state',
        'status',
        'services',
        'downtime'
    ],
    data() {
        return {
            hostScheduleResetCheckTime: false,
            ScheduleMaintenance: false,
            acknowledge: false,
            togglePassiveColapse: false,
            flapDetect: false,
            notification: false,
            toggleCustomNotification: false
        }
    },
    computed: {
        getUuid: function(){
            return this.hostuuid;
        },
        getHostStatus: function(){
            return this.status;
        },
        getServices: function(){
            return this.services;
        },
        getDowntime: function(){
            return this.downtime;
        },
        getDeleteDowntimePermission: function(){
            return this.$store.state.canDeleteDowntimes;
        },
    },
    methods: {
        setform: function (toggle){
            switch (toggle){
                case 'hostScheduleResetCheckTime':
                    this.hostScheduleResetCheckTime = !this.hostScheduleResetCheckTime;
                    break;
                case 'ScheduleMaintenance':
                    this.ScheduleMaintenance = !this.ScheduleMaintenance;
                    break;
                case 'acknowledge':
                    this.acknowledge = !this.acknowledge;
                    break;
                case 'togglePassiveColapse':
                    this.togglePassiveColapse = !this.togglePassiveColapse;
                    break;
                case 'flapDetect':
                    this.flapDetect = !this.flapDetect;
                    break;
                case 'notification':
                    this.notification = !this.notification;
                    break;
                case 'toggleCustomNotification':
                this.toggleCustomNotification = !this.toggleCustomNotification;
                default:
                    // this.$refs.togglePassiveColapse.click();
                    break;
            }

        },
        actionRefresh(toggle){

            switch (toggle){
                case 'hostScheduleResetCheckTime':
                    this.hostScheduleResetCheckTime = false;
                    break;
                case 'ScheduleMaintenance':
                    this.ScheduleMaintenance = false;
                    break;
                case 'acknowledge':
                   this.acknowledge = false;
                    break;
                case 'togglePassiveColapse':
                   this.togglePassiveColapse = false;
                    break;
                case 'flapDetect':
                  this.flapDetect = false;
                    break;
                case 'notification':
                   this.notification = false;
                    break;
                case 'toggleCustomNotification':
                   this.toggleCustomNotification = false;
                default:
                    break;
                }
            setTimeout(() => {
                this.$emit('refresh-event')
            }, 7000);
        }
    }
}
</script>

<style scoped>

</style>
